import React from "react";
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  z-index: 115;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 678px;
  min-width: 500px;

  @media (max-width: 600px) {
    min-width: unset;
    width: 100%;
  }
`;

const AnnouncementContainer = styled.div`
  position: relative;
  background: #f9b427;
  border: 3px solid #ffe0a0;
  border-radius: 20px;
  padding: 16px;
  font-family: var(--font-inter, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
  display: flex;
  gap: 16px;
  margin: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 12px;
  }
`;

const Icon = styled.img`
  @media (max-width: 600px) {
    width: 57px;
    height: 57px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  line-height: 0;
  padding: 0;
`;

const AnnouncementContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Title = styled.p`
  margin: 0;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: #111111;
  letter-spacing: 0;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const Message = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #111111;
  letter-spacing: 0%;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

type MaintenanceProps = {
  announcement: string;
  onClose: () => void;
  title?: string;
};

export function MaintenanceAnnouncement({
  announcement,
  onClose,
  title = "System Maintenance",
}: MaintenanceProps) {
  return (
    <Container role="alert">
      <AnnouncementContainer>
        <CloseButton onClick={onClose} aria-label="Close">
          <img src="images/maintenance-close.svg" alt="" />
        </CloseButton>
        <Icon src="images/maintenance-icon.svg" alt="" aria-hidden />
        <AnnouncementContent>
          <Title>{title}</Title>
          <Message>{announcement}</Message>
        </AnnouncementContent>
      </AnnouncementContainer>
    </Container>
  );
}
